import React from "react";
import ReactDOM from "react-dom/client";

import "./css/feature1.css";
import "./css/feature2.css";
import "./css/feature3.css";
import "./css/feature4.css";
import "./css/feature5.css";
import "./css/feature6.css";
import "./css/feature7.css";
import "./css/feature8.css";
import "./css/feature9.css";
import "./css/links.css";
import "./css/paymentForms.css";
import "./css/login.css";
import "./index.css";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
